@for (product of sortedProducts(); track product) {
  <app-product-card
    [product]="product"
    (toBeOrdered)="order.emit($event)"
    />
}
